<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#open-banking-wallet-settings" role="tab"
                           aria-selected="false">
                            {{ $t('open_banking_wallet.settings') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div class="tab-pane active" id="open-banking-wallet-settings">
                    <open-banking-wallet-settings></open-banking-wallet-settings>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</template>

<script>


import toastr from "toastr";
import OpenBankingWalletSettings from './OpenBankingWalletSettings'

export default {
    components: {
        'open-banking-wallet-settings': OpenBankingWalletSettings
    },
    data() {
        return {}
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {}
}
</script>

<style>

</style>